export function extrairIdsSelecionados<
  T extends { value: string | null | undefined }
>(opcoes: (T | null | undefined)[]): string[] {
  return opcoes.map(o => o?.value).filter(Boolean) as string[]
}
